import React from 'react'
import logo from "../../assets/logos/TRANSKYRIOS-_IconColor.avif";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import Permiso from '../../components/wrappers/permiso';
import ContactoTI from "../../components/contacto-ti/contacto-ti";
import ModuleLayout from '../../layouts/layout-modulo.js';
import "../../layouts/layout-modulo.css"

function PanelPrevencion() {
  const navigate = useNavigate();
  const verChkSomnolencia = () => { navigate('ver/checklists-somnolencia'); };
  const verChkVehiculo = () => { navigate('ver/checklists-vehiculos'); };

  return (
    <ModuleLayout titulo="Panel Prevención" logo={logo} onVolver={() => navigate('/app')}>
      <section className="mod-content">
        <div className='mod-banner'>
          <p className="m-0">
            Aquí podrá hacer seguimiento a la operación de la conducción de vehículos, 
            como los checklist de somnolencia y vehículo. Además, podrá consultar y descargar la información de cada checklist. 
          </p>
        </div>

        <div className='container-cards'>
          <Permiso modulo="Panel Prevención" permiso="PRE_VER_REGSOM">
            <div className="mod-card">
              <Card
                title="Ver Registros de Fatiga y Somnolencia"
                className="card-dash"
                footer={ 
                  <Button className="btn btn-outline-primary" 
                    label="Ver Registros"
                    icon="pi pi-table" 
                    onClick={verChkSomnolencia} 
                  />
                }
              >
                <p>
                  Esta funcionalidad permite acceder a una tabla <b>resumen con todos 
                  los chacklist de fatiga y somnolencia generados hasta la fecha</b>.
                </p> 
              </Card>
            </div>
          </Permiso>

          <Permiso modulo="Panel Prevención" permiso="PRE_VER_REGVEH">
            <div className="mod-card">
              <Card
                title="Ver Registros de Revisión Vehicular"
                className="card-dash"
                footer={ 
                  <Button className="btn btn-outline-primary"
                    label="Ver Registros"
                    icon="pi pi-table"
                    onClick={verChkVehiculo}
                  />
                }
              >
                <p>
                  Esta funcionalidad permite acceder a una tabla <b>resumen con todos 
                  los chacklist de revisión vehicular generados hasta la fecha</b>.
                </p>
              </Card>
            </div>
          </Permiso>
        </div>
        
        <ContactoTI />
      </section>
    </ModuleLayout>
  );
}

export default PanelPrevencion